// axios.js
import axios from "axios";
import config from "./config.js";
import { store } from 'Store/store.index';
import { isMacSsoNoIos } from 'Utils/device';
import { isSafari } from 'Utils/browser-info';
//import { Message, Loading } from "element-ui";
// import { Toast } from "vant";
const service = axios.create(config);
const CancelToken = axios.CancelToken;
const requestContinue = 10;

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 储存需要被手动取消的请求
    config.cancelToken = new CancelToken((cancel) => {
      store.common.axiosPromiseList.push(cancel);
    });
    if (config.showLoading) {
      // Toast.loading({
      //   message: config.loadingText ? config.loadingText : "加载中...",
      //   forbidClick: true,
      //   duration: 0
      // });
      // store.commit("axios/UPDATE_ADD_REQUEST_COUNT");
    }
    if (config.formData) {
      config.data = config.formData;
    }
    // 这里处理一个特殊逻辑，在mac下docs接口不携带cookies，通过configUrl判断
    if((isMacSsoNoIos || isSafari) && config.url.includes('https://docsapi.foxitcloud.cn')) {
      config.withCredentials = false
    }
    console.log("store.loginNewStore.IAMToken")
    console.log(!!store.loginNewStore.IAMToken)
    if (store.loginNewStore.IAMToken && !config.url.includes('/createIamToken') ) {
      config.headers = {...config.headers, Authorization: `Bearer ${store.loginNewStore.IAMToken}`}
    }
    return config;
  },
  error => {
    // store.commit("axios/UPDATE_SUBTRACT_REQUEST_COUNT");
    return Promise.error(error);
  }
);
// 响应拦截器
service.interceptors.response.use(
  response => {
    // store.commit("axios/UPDATE_SUBTRACT_REQUEST_COUNT");
    setTimeout(() => {
      if (
        !response.config.banClearLoading
      ) {
        // Toast.clear();
      }
    }, requestContinue);
    if (response.status === 200 || response.status === 201) {
      switch (response.data.ret) {
        case 400:
          return Promise.reject(response);
          break;
        case 401:
        //   if(store.loginNewStore.isLogin) {
        //     store.common.isShowLoginLoseDialog = true
        //   }
          // else {
          //   store.loginNewStore.login()
          // }
          return Promise.resolve(response);
          // break;
        default:
          return Promise.resolve(response);
      }
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    // store.commit("axios/UPDATE_SUBTRACT_REQUEST_COUNT");
    // 处理请求超时
    if (error.code === "ECONNABORTED" && error.message.includes("timeout")) {
      let config = error.config;
      if (!config || !config.retry) return Promise.reject(error);
      config.__retryCount = config.__retryCount || 0;
      if (config.__retryCount >= config.retry) {
        setTimeout(() => {
          // if (store.state.axios.requestCount === 0) Toast.clear();
        }, requestContinue);
        // Message.error({
        //   message: "请求超时,请重试!"
        // });
        return Promise.reject(error);
      }
      config.__retryCount += 1;
      let backOff = new Promise(function(resolve) {
        setTimeout(function() {
          resolve();
        }, config.retryDelay || 1);
      });
      return backOff.then(function() {
        return service(config);
      });
    }
    setTimeout(() => {
      // if (store.state.axios.requestCount === 0) Toast.clear();
    }, requestContinue);
    // 异常状态作统一处理
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = "错误请求";
          break;
        case 401:
          error.message = "未授权，请重新登录";
          break;
        case 403:
          error.message = "拒绝访问";
          break;
        case 404:
          error.message = "请求错误,未找到该资源";
          break;
        case 405:
          error.message = "请求方法未允许";
          break;
        case 408:
          error.message = "请求超时";
          break;
        case 500:
          error.message = "服务器端出错";
          break;
        case 501:
          error.message = "网络未实现";
          break;
        case 502:
          error.message = "网络错误";
          break;
        case 503:
          error.message = "服务不可用";
          break;
        case 504:
          error.message = "网络超时";
          break;
        case 505:
          error.message = "http版本不支持该请求";
          break;
        default:
          error.message = `连接错误${error.response.status}`;
      }
    } else {
      error.message = "连接到服务器失败";
    }
    return Promise.reject(error);
  }
);

export default function() {
  return service;
}
